// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    CalendarSearch,
    CalendarSync,
    CalendarX,
    CalendarX2,
    Calendars,
    Camera,
    CameraOff,
    Can,
    CanSoda,
    Candy,
    CandyCane,
    CandyOff,
    Cannabis,
    CannabisOff,
    Captions,
    CaptionsOff,
    Car,
    CarBattery,
    CarFront,
    CarTaxiFront,
    Caravan,
    CardSim,
    Carrot,
    CaseLower,
    CaseSensitive,
    CaseUpper,
    CassetteTape,
    Cast,
    Castle,
    Cat,
    Cctv,
    CctvOff,
    ChartArea,
    ChartBar,
    ChartBarBig,
    ChartBarDecreasing,
    ChartBarIncreasing,
    ChartBarStacked,
    ChartCandlestick,
    ChartColumn,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "calendar-search" through "chart-column", inclusive. */
const shard: Record<string, LucideIcon> = {
    "calendar-search": CalendarSearch,
    "calendar-sync": CalendarSync,
    "calendar-x": CalendarX,
    "calendar-x-2": CalendarX2,
    calendars: Calendars,
    camera: Camera,
    "camera-off": CameraOff,
    can: Can,
    "can-soda": CanSoda,
    candy: Candy,
    "candy-cane": CandyCane,
    "candy-off": CandyOff,
    cannabis: Cannabis,
    "cannabis-off": CannabisOff,
    captions: Captions,
    "captions-off": CaptionsOff,
    car: Car,
    "car-battery": CarBattery,
    "car-front": CarFront,
    "car-taxi-front": CarTaxiFront,
    caravan: Caravan,
    "card-sim": CardSim,
    carrot: Carrot,
    "case-lower": CaseLower,
    "case-sensitive": CaseSensitive,
    "case-upper": CaseUpper,
    "cassette-tape": CassetteTape,
    cast: Cast,
    castle: Castle,
    cat: Cat,
    cctv: Cctv,
    "cctv-off": CctvOff,
    "chart-area": ChartArea,
    "chart-bar": ChartBar,
    "chart-bar-big": ChartBarBig,
    "chart-bar-decreasing": ChartBarDecreasing,
    "chart-bar-increasing": ChartBarIncreasing,
    "chart-bar-stacked": ChartBarStacked,
    "chart-candlestick": ChartCandlestick,
    "chart-column": ChartColumn,
};

export default shard;
